import { render, staticRenderFns } from "./GymUserAscents.vue?vue&type=template&id=07703710"
import script from "./GymUserAscents.vue?vue&type=script&lang=js"
export * from "./GymUserAscents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports